import { isNumber } from "@suse-o11y/is-number";

import { isDate } from "./date-fns";

export type Time = number | Date;

export function isTime(input: unknown): input is Time {
	return isNumber(input) || isDate(input);
}
